<template>
  <div class="Aggregate_statistics">
    <div class="Aggregate_statistics_top">
      <div style="height: 100%;background-color: #fff;width: 60%;float: left;border-radius:10px">
        <ul>
            <li>
              <h3>{{data.projectPersonNumber? data.projectPersonNumber.evaluationsNumber:'0'}}</h3>
              <p>测评总人数</p>
            </li>
            <li>
              <h3>{{data.projectPersonNumber?data.projectPersonNumber.inquiriesNumber:'0'}}</h3>
              <p>咨询总人数</p>
            </li>
            <li>
              <h3>{{data.projectPersonNumber?data.projectPersonNumber.crisisNumber:'0'}}</h3>
              <p>危机总人数</p>
            </li>
            <li>
              <h3>{{data.projectPersonNumber?data.projectPersonNumber.eventNumber:'0'}}</h3>
              <p>活动人数</p>
            </li>
            <li>
              <h3>{{data.projectPersonNumber?data.projectPersonNumber.trainingNumber:'0'}}</h3>
              <p>培训人数</p>
            </li>

            <li>
              <h3>{{data.projectPersonNumber?data.projectPersonNumber.promotionsNumber:'0'}}</h3>
              <p>宣传数量</p>
            </li>

            <li>
              <h3>待添加</h3>
              <p>热线人数</p>
            </li>

            <li>
              <h3>待添加</h3>
              <p>访谈人数</p>
            </li>


          </ul>
      </div>
      <div style="height: 100%;background-color: #fff;width: 39%;float: left;margin-left:1%;border-radius:10px">
        <div class="right" style="margin-top:10px">
          <!-- <el-button @click="cscoi(1058)"  class="minbtn" style="margin-left:20px"  size="mini">学生</el-button>
          <el-button @click="cscoi(1075)"  class="minbtn" size="mini">教职工</el-button> -->
          <el-select @change="cscoi" style="margin-left:20px;" v-model="role" placeholder="请选择活动区域">
            <el-option label="全部" value=""></el-option>
            <el-option label="学生" value="1058"></el-option>
            <el-option label="教职工" value="1075"></el-option>
          </el-select>
          <el-button @click="querycensus(1)" style="margin-left:20px;" class="minbtn"  size="mini">近一月</el-button>
          <el-button @click="querycensus(2)" style="margin-left:20px;" class="minbtn"  size="mini">近三月</el-button>
          <el-button @click="querycensus(6)" style="margin-left:20px;" class="minbtn"  size="mini">近半年</el-button>
          <el-button @click="querycensus(12)"  class="minbtn" size="mini">近一年</el-button><br>
          <el-date-picker @change='changefun()' value-format="yyyy-MM-dd"  format="yyyy-MM-dd" style="margin-left:20px;margin-top:20px"  v-model="value1" type="daterange"  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"></el-date-picker>
          <el-button type="primary" style="margin-left:20px;" @click="czfun()">重置</el-button>
        </div>
      </div>
    </div>

    <ul class="Aggregate_statistics_nav">
      <li style="margin-left: 0%;">
        <!-- <el-button @click="gourl()" style="float: right;margin-right:20px;" type="text">查看更多></el-button> -->
        <div ref="Trainingcontentstatistics"  style="width:100%;height:350px;margin: auto;margin-top:60px;"></div>
      </li>
      <li style="margin-left: 1%;">
        <el-button @click="gourl('../Admin/ExamineStatistical')" style="float: right;margin-right:20px;" type="text">查看更多></el-button>
        <div ref="peopleNumByDegree" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:60px;"></div>
      </li>
      <li style="margin-left: 1%;">
        <el-button @click="gourl('../Crisis/Crisis_statistics')" style="float: right;margin-right:20px;" type="text">查看更多></el-button>
        <div ref="peopleNumByDegree2" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:60px;"></div>
      </li>
    </ul>

    <ul class="Aggregate_statistics_nav">
      <li style="margin-left: 0%;">
        <el-button @click="gourl('../Activity/Activity_Profile')" style="float: right;margin-right:20px;" type="text">查看更多></el-button>
        <div ref="Piechart" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div>
      </li>
      <li style="margin-left: 1%;">
        <el-button @click="gourl('../Education/trainingstatistics')" style="float: right;margin-right:20px;" type="text">查看更多></el-button>
        <div ref="peopleNumByDegree3" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:60px;"></div>
      </li>
      <li style="margin-left: 1%;">
        <el-button @click="gourl('../propagate/User_analysis')" style="float: right;margin-right:20px;" type="text">查看更多></el-button>
        <div ref="peopleNumByDegree4" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:60px;"></div>
      </li>
    </ul>

  </div>
</template>
<script>

export default {
  data() {
    return {
      region:'',
      beginTime:'',
      endTime:'',
      value1:this.Global.querycensus(6),
      data:[],
      role:'',
    }
  },
  methods: {
    czfun(){
      this.beginTime=this.Global.querycensus(6)[0];
      this.endTime=this.Global.querycensus(6)[1];
      this.value1 = this.Global.querycensus(6)
      this.getallstatisticslist();
    },
    gourl(url){
      this.$router.push(url)
    },
    cscoi(a){
      // this.getallstatisticslist();
    },
    //根据选项查询 
    querycensus(data){
      // this.value1 = this.Global.querycensus(data)
      const censusDate= this.Global.querycensus(data);
      this.beginTime=censusDate[0];
      this.endTime=censusDate[1];
      this.getallstatisticslist();
    },
    getallstatisticslist(){
      this.$Http_Post("/staging/getStatisticalData",{ startTime: this.beginTime,endTime: this.endTime,role:this.role }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
          this.contentstatistics();
          this.peopleNumByDegree();
          this.peopleNumByDegree2();
          this.peopleNumByDegree3();
          this.peopleNumByDegree4();
          this.Piechart();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    changefun(){
      this.$Http_Post("/staging/getStatisticalData",{ startTime: this.value1[0],endTime: this.value1[1],role:this.role }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
          this.contentstatistics();
          this.peopleNumByDegree();
          this.peopleNumByDegree2();
          this.peopleNumByDegree3();
          this.peopleNumByDegree4();
          this.Piechart();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    contentstatistics(){
      var myChart = this.$echarts.init(this.$refs.Trainingcontentstatistics);
      var option={
        tooltip: {},
        title: {
          text: this.data.scaleTestStatisticsChart.chartTitle,
          left: '20px',
          top: '10px',
        },
        color:['#93C22D', '#557CD9'],
        legend: {
          right:'20',
          top:'10',
          data:['普测风险人数', '访谈后风险人数',]
        },
        xAxis: { type: 'category',data:this.data.scaleTestStatisticsChart.results},
        yAxis: { splitLine: { show: true, lineStyle: { type: 'dashed' } } },
        series: [
          { 
            name:'普测风险人数',
            data: this.data.scaleTestStatisticsChart.scaleTestCounts,
            type: 'bar',
            smooth: true,
            barWidth: '15', 
          },{
            name:'访谈后风险人数',
            data: this.data.scaleTestStatisticsChart.interViewCounts,
            type: 'bar',
            smooth: true,
            barWidth: '15', 
          }
        ]
      }
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    peopleNumByDegree(data) {
      var myChart = this.$echarts.init(this.$refs.peopleNumByDegree);
      var option = {
        tooltip: {
           trigger: 'axis'
        },
        title: {
          text: '咨询人数统计',
          left: '20px',
          top: '0px',
        },
        legend: {
          data: ['预约人数','咨询人数','高危个案人数','咨询上报人数'],
          top: '5px',
          right:'10px',
        },
        xAxis: {
          type: 'category',
          data: this.data.consultationChart.results
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name:'预约人数',
            data: this.data.consultationChart.reserveSums,
            type: 'line',
            smooth: true,
            color: 'rgba(68, 185, 172, 1)'  
          },
          {
            name:'咨询人数',
            data: this.data.consultationChart.consultSums,
            type: 'line',
            smooth: true,
            color: 'rgba(227, 181, 64, 1)'  
          },
          {
            name:'高危个案人数',
            data: this.data.consultationChart.highRiskSums,
            type: 'line',
            smooth: true,
            color: 'rgba(156, 196, 54, 1)'  
          },
          {
            name:'咨询上报人数',
            data: this.data.consultationChart.reportSums,
            type: 'line',
            smooth: true,
            color: 'rgba(255, 84, 84, 1)'  
          },
        ]
      };

      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });

    },
    peopleNumByDegree2(data) {
      var myChart = this.$echarts.init(this.$refs.peopleNumByDegree2);
      var option = {
        tooltip: {
           trigger: 'axis'
        },
        title: {
          text: '危机上报人数',
          left: '20px',
          top: '0px',
        },
        legend: {
          data: ['日常上报','自主上报','咨询上报','测评上报','热线上报'],
          top: '5px',
          right:'10px',
        },
        xAxis: {
          type: 'category',
          data: this.data.crisisChart.results
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name:'日常上报',
            data: this.data.crisisChart.dailyNums,
            type: 'line',
            smooth: true,
            color: 'rgba(68, 185, 172, 1)'  
          },
          {
            name:'自主上报',
            data: this.data.crisisChart.ownNums,
            type: 'line',
            smooth: true,
            color: 'rgba(227, 181, 64, 1)'  
          },
          {
            name:'咨询上报',
            data: this.data.crisisChart.consultNums,
            type: 'line',
            smooth: true,
            color: 'rgba(156, 196, 54, 1)'  
          },
          {
            name:'测评上报',
            data: this.data.crisisChart.testNums,
            type: 'line',
            smooth: true,
            color: 'rgba(255, 84, 84, 1)' 
          },
          {
            name:'热线上报',
            data: this.data.crisisChart.hotNums,
            type: 'line',
            smooth: true,
            color: 'rgba(255, 84, 84, 1)'  
          },
        ]
      };

      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });

    },
    peopleNumByDegree3(data) {
      var myChart = this.$echarts.init(this.$refs.peopleNumByDegree3);
      var option = {
        tooltip: {
           trigger: 'axis'
        },
        title: {
          text: '考试培训人数统计',
          left: '20px',
          top: '0px',
        },
        legend: {
          data: ['培训人数','考试人数','合格人数'],
          top: '5px',
          right:'10px',
        },
        xAxis: {
          type: 'category',
          data: this.data.statisticalChart.month
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name:'培训人数',
            data: this.data.statisticalChart.totalNum,
            type: 'line',
            smooth: true,
            color: 'rgba(68, 185, 172, 1)'  
          },
          {
            name:'考试人数',
            data: this.data.statisticalChart.examNum,
            type: 'line',
            smooth: true,
            color: 'rgba(227, 181, 64, 1)'  
          },
          {
            name:'合格人数',
            data: this.data.statisticalChart.passNum,
            type: 'line',
            smooth: true,
            color: 'rgba(156, 196, 54, 1)'  
          }
        ]
      };

      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });

    },
    peopleNumByDegree4(data) {
      var myChart = this.$echarts.init(this.$refs.peopleNumByDegree4);
      var option={
        tooltip: {
           trigger: 'axis'
        },
        title: {
          text: '栏目内容统计',
          left: '20px',
          top: '0px',
        },
        legend: {
          right:'20',
          top:'10',
          data:['点赞量','转发量','阅读量']
        },
        xAxis: { type: 'category',data:this.data.promotionChart.result},
        yAxis: { splitLine: { show: true, lineStyle: { type: 'dashed' } } },
        series: [
          { 
            name:'点赞量',
            data: this.data.promotionChart.likeCounts,
            type: 'bar',
            smooth: true,
            barWidth: '15', 
            color: 'rgba(227, 181, 64, 1)'  
          },{
            name:'转发量',
            data: this.data.promotionChart.forwardCounts,
            type: 'bar',
            smooth: true,
            barWidth: '15', 
            color: 'rgba(227, 181, 64, 1)'  
          },
          {
            name:'阅读量',
            data: this.data.promotionChart.readCounts,
            type: 'bar',
            smooth: true,
            barWidth: '15', 
            color: 'rgba(156, 196, 54, 1)'  
          }
        ]
      }
      // var option = {
  
    
      //   xAxis: {
      //     type: 'category',
      //     data: this.data.promotionChart.result
      //   },
      //   yAxis: {
      //     type: 'value'
      //   },
      //   series: [
      //     {
      //       name:'点赞量',
      //       data: this.data.promotionChart.likeCounts,

      //       type: 'line',
      //       smooth: true,
      //       color: 'rgba(68, 185, 172, 1)'  
      //     },
      //     {
      //       name:'转发量',
      //       data: this.data.promotionChart.forwardCounts,
      //       type: 'line',
      //       smooth: true,
      //       color: 'rgba(227, 181, 64, 1)'  
      //     },
      //     {
      //       name:'阅读量',
      //       data: this.data.promotionChart.readCounts,
      //       type: 'line',
      //       smooth: true,
      //       color: 'rgba(156, 196, 54, 1)'  
      //     },
      //   ]
      // };

      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });

    },
    Piechart(){
      var myChart = this.$echarts.init(this.$refs.Piechart);
      var option = {
        tooltip: {
          trigger: 'item'
        },
        color:['#45C2E0', '#C1EBDD', '#FFC851'],
        title: {
          text: '活动内容数量统计',
          left: '20px',
          top: '10px',
        },
        legend: {
          top: '90%',
          left: 'center',
          selectedMode: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            data: [
              { value: this.data.eventStatisticsListChart[0].count, name: '冥想音乐' },
              { value: this.data.eventStatisticsListChart[1].count, name: '正念训练' },
              { value: this.data.eventStatisticsListChart[2].count, name: '情绪调节' },
            ]
          }
        ]
      };

      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
  mounted() {
    this.querycensus(6)
  },
  updated() {
  },
}
</script>
<style>
.Aggregate_statistics {width: 100%;height: 100%;overflow: auto;}
.Aggregate_statistics .Aggregate_statistics_top{height: 140px;}
.Aggregate_statistics_nav {height: 480px;margin-top: 14px;}
.Aggregate_statistics_nav li {float: left;width: 32.6%;background-color: #fff;height: 100%;border-radius:10px}
.Aggregate_statistics_top  ul li {float: left;width: 10%;text-align: left;}
.Aggregate_statistics_top ul {margin-top: 30px;}
.Aggregate_statistics_top ul li h3 {margin-left: 20px;font-size: 24px;color: rgba(0, 136, 255, 1);padding-top: 10px;}
.Aggregate_statistics_top ul li p {margin-left: 20px;margin-top: 10px;}
</style>
